namespace $.$$ {
	export class $mol_transit_demo extends $.$mol_transit_demo {
		
		
		
	}
}
